import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEn from './langs/en';
import translationEl from './langs/el';
import { isPreviewPath } from '../invitation/previewPath.js';

const detector = new LanguageDetector();

// ?lang=en|el override — wins over localStorage so the dashboard upsell
// link (and any deep link a couple shares) can force the invitation's UI
// chrome into a specific language. Without this, i18next falls back to
// the last cached choice and ignores the URL, producing mixed-language
// pages (e.g. Greek nav over English /public content). Maps the short
// code to the canonical i18next code used in `supportedLngs`.
detector.addDetector({
  name: 'querystringMapped',
  lookup() {
    if (typeof window === 'undefined') return undefined;
    const raw = new URLSearchParams(window.location.search).get('lang');
    if (!raw) return undefined;
    const lower = raw.toLowerCase();
    if (lower.startsWith('el')) return 'elGR';
    if (lower.startsWith('en')) return 'enUS';
    return undefined;
  },
});

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      enUS: { translation: translationEn },
      elGR: { translation: translationEl },
    },
    supportedLngs: ['enUS', 'elGR'],
    fallbackLng: 'enUS',
    ns: ['translation'],
    defaultNS: 'translation',
    detection: {
      // Order is intentional: `?lang=` always wins, then a previously
      // saved choice (e.g. the user picked Greek via the in-page switcher)
      // persists across visits. The browser/system language is deliberately
      // NOT consulted — invitations default to English unless the URL or a
      // prior explicit choice says otherwise.
      order: ['querystringMapped', 'localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // The editor's preview (/preview) is told its language with every
      // render; remembering it would hand the couple's editor language to
      // their next visit to a real invitation in this browser.
      caches: isPreviewPath() ? [] : ['localStorage'],
    },
    interpolation: { escapeValue: false },
    debug: false,
  });

export default i18n;
